import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MonitoringService } from '../services/monitoring.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class MonitoringGymsResolver implements Resolve<Observable<string>> {

    constructor(private monitoringService: MonitoringService) { }

    resolve() {
        return this.monitoringService.getMonitoringGymList().catch(() => {
            return Observable.of('error');
        });
    }

}

